export class StaffDisability { 
    id : number;  
    staffId: number;
    fullName : string;
    typeOfDisabilityId : number;
}